var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{class:[_vm.canceled ? 'text-decoration-line-through' : '', _vm.color]},[_vm._v(_vm._s(_vm.$format.decimal(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }